<app-data-table
  [columns]="columns"
  [data]="discounts"
  [filters]="filters"
  [rowActions]="rowActions"
  [sort]="sort"
  [rowClickable]="true"
  [rowId]="rowId"
  testId="listing-table"
  minTableWidth="1280px"
  (sortChange)="onSortChange($event)"
  (filterChange)="onFilterChange($event)"
  (rowClick)="viewDiscount.emit($event)"
  (rowAction)="onRowAction($event)"
>
  <ng-template appDataTableCell="created_at" let-row>
    <span class="cell-text">{{ row.created_at | date: 'MMM d y, h:mma' }}</span>
  </ng-template>

  <ng-template appDataTableCell="name" let-row>
    <span class="name-text">{{ row.name }}</span>
  </ng-template>

  <ng-template appDataTableCell="type" let-row>
    <span class="customer-type-tag" [ngClass]="typeBadgeClass(row)">{{ typeBadgeLabel(row) }}</span>
  </ng-template>

  <ng-template appDataTableCell="status" let-row>
    <span class="customer-type-tag" [ngClass]="statusClass(row)">{{ statusLabel(row) }}</span>
  </ng-template>

  <ng-template appDataTableCell="locations" let-row>
    <span class="cell-text location-text">{{ locations(row.locations) }}</span>
  </ng-template>

  <ng-template appDataTableCell="discount_amount" let-row>
    <span class="cell-text">{{ amount(row.discount_type, row.discount_value) }}</span>
  </ng-template>

  <ng-template appDataTableCell="times_applied" let-row>
    <span class="cell-text">{{ timesApplied(row) }}</span>
  </ng-template>

  <ng-template appDataTableCell="updated_at" let-row>
    <span class="cell-text">{{
      row.updated_at ? (row.updated_at | date: 'MMM d y, h:mma') : '-'
    }}</span>
  </ng-template>
</app-data-table>
